export class PurchasedLicensesInfo {
  PurchasedLicensesID: number;
  PurchasingOrganizationID: number;
  RelationshipToRequestedOrganization: string;
  PurchasingOrganizationDescription: string;
  Quantity: number;
  PurchaseDate: Date;
  LicenseStartDate: Date;
  LicenseEndDate: Date;
  IsInGracePeriod: boolean;
  IsGracePeriodDisabled: boolean;
  PurchaseDollarAmount: number;
  LicenseLengthYears: number;
  ARR: number;
  LicensePurchaseType: string;
  PurchaseLevel: string;
  Note: string;
  PurchaseOrderID: string;
  DealID: string;
  InvoiceID: string;
  PurchasesRenewedByThisPurchase: PurchasedLicensesCrossRef[];
}

export class PurchasedLicensesCrossRef {
  PurchasedLicensesID: number;
}